'use strict';

angular.module('fetchtv.Directives')
  .directive('ftMatch', function($parse) {
    return {
      require: 'ngModel',
      link: function(scope, elem, attrs, ctrl) {
        function shouldMatch() {
          var shouldMatch = true;

          if (attrs['mismatch']) {
            shouldMatch = !(attrs['mismatch'] === 'true');
          }

          return shouldMatch;
        }

        scope.$watch(function() {
          if (shouldMatch()) {
            return $parse(attrs.ftMatch)(scope) === ctrl.$modelValue;
          } else {
            return $parse(attrs.ftMatch)(scope) !== ctrl.$modelValue;
          }
        }, function(currentValue) {
          var errorTag = shouldMatch() ? 'mismatch' : 'match';
          ctrl.$setValidity(errorTag, currentValue);
        });
      }
    };
  });
